import React from "react";

const ExitMarkIcon = ({ color = "black" }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5183_2795)">
        <path
          d="M9.5 0C4.25333 0 0 4.25333 0 9.5C0 14.747 4.25333 19 9.5 19C14.747 19 19 14.747 19 9.5C19 4.25333 14.747 0 9.5 0ZM9.5 17.8312C4.91655 17.8312 1.1875 14.0835 1.1875 9.49996C1.1875 4.91651 4.91655 1.18746 9.5 1.18746C14.0835 1.18746 17.8125 4.91653 17.8125 9.49996C17.8125 14.0834 14.0835 17.8312 9.5 17.8312Z"
          fill={color}
        />
        <path
          d="M13 6L6 13M6 6L13 13"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5183_2795">
          <rect width="19" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ExitMarkIcon;
